import React from 'react'
import cs from 'classnames'
import styles from './navBar.scss'

const NavItem = ({ id, icon, title, key, onClick, active, userStyles }) => {
	return (
		<div
			key={key}
			onClick={() => onClick(id)}
			className={`${styles.item} ${(active === id) ? styles.active : ''} `}
		>
			<div className={`${styles.iconContainer} ${styles.avatarIcon}`}>
				{icon}
			</div>
			<div className={styles.textContainer}>
				{title}
			</div>
		</div>
	)
}

const NavSection = ({ activeId, align, items, onClick, userStyles }) => {
	return (
		<div className={`${styles.section} ${align}`}>
			{items && items.map((item, i) => (
				<NavItem
					active={activeId}
					onClick={onClick}
					icon={item.icon}
					id={item.id}
					key={i}
					title={item.title}
					userStyles={userStyles}
				/>
			))}
		</div>
	)
}

const NavBar = ({ activeId, brand, userStyles, leftItems, onClick, rightItems, className, isPhone, isTablet }) => {
	return (
		<div className={cs(styles.navBar, className)}>
			<div className={styles.navMenu}>
				{(!isPhone && !isTablet) &&
					<div className={styles.brandContainer}>{brand}</div>
				}
				<NavSection
					activeId={activeId}
					align={''}
					onClick={onClick}
					items={leftItems}
					userStyles={userStyles}
				/>
				<NavSection
					activeId={activeId}
					align={styles.justRight}
					onClick={onClick}
					items={rightItems}
					userStyles={userStyles}
				/>
			</div>
		</div>
	)
}
export default NavBar



// WEBPACK FOOTER //
// ./elements/NavBar.jsx